export default __webpack_public_path__ + "static/media/CNo.85-5.f1467798.jpg";